import { render, staticRenderFns } from "./ImageMenu.vue?vue&type=template&id=939bfa86"
import script from "./ImageMenu.vue?vue&type=script&lang=js"
export * from "./ImageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('939bfa86')) {
      api.createRecord('939bfa86', component.options)
    } else {
      api.reload('939bfa86', component.options)
    }
    module.hot.accept("./ImageMenu.vue?vue&type=template&id=939bfa86", function () {
      api.rerender('939bfa86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/ImageMenu.vue"
export default component.exports